import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { PrijskaartPage } from "@/pages/prijskaart";

export const Route = createFileRoute("/$lang/pricing-sheet")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "pricing");
    return pageHead({
      lang,
      pathWithoutLang: "/prijskaart",
      title: t("seo.title"),
      description: t("seo.description"),
    });
  },
  component: PrijskaartPage,
});
